import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { postJson } from "../auth/api";
import { Button, Drawer } from "../components/ui";

const publicLinks = [
  ["/", "Trang chủ"],
  ["/dogs", "Hồ sơ chó"],
] as const;

export function PublicShell() {
  const [open, setOpen] = useState(false);
  const { principal, loading, clear } = useAuth();
  const navigate = useNavigate();

  async function logout() {
    await postJson("/api/v1/auth/logout", {}).catch(() => undefined);
    clear();
    setOpen(false);
    navigate("/", { replace: true });
  }

  const navigation = (
    <nav className="topnav" aria-label="Điều hướng công khai">
      {publicLinks.map(([to, label]) => (
        <NavLink key={to} to={to} end={to === "/"} onClick={() => setOpen(false)}>{label}</NavLink>
      ))}
      {!loading && principal ? (
        <>
          <NavLink className="nav-cta" to="/member/dogs/new" onClick={() => setOpen(false)}>Đăng chó</NavLink>
          <NavLink to="/member/dogs" onClick={() => setOpen(false)}>Chó của tôi</NavLink>
          <NavLink to="/member" onClick={() => setOpen(false)}>Khu vực thành viên</NavLink>
          <NavLink to={`/u/${principal.publicSlug}`} onClick={() => setOpen(false)}>Hồ sơ công khai</NavLink>
          <button type="button" className="nav-action" onClick={() => void logout()}>Đăng xuất</button>
        </>
      ) : !loading ? (
        <>
          <NavLink className="nav-cta" to="/login" state={{ returnTo: "/member/dogs/new" }} onClick={() => setOpen(false)}>Đăng chó</NavLink>
          <NavLink to="/login" onClick={() => setOpen(false)}>Đăng nhập</NavLink>
          <NavLink to="/register" onClick={() => setOpen(false)}>Đăng ký</NavLink>
        </>
      ) : null}
    </nav>
  );

  return (
    <div className="app-frame">
      <header className="topbar">
        <NavLink className="brand" to="/" aria-label="WorkingDog VN trang chủ">
          <span className="brand-mark" aria-hidden="true">WD</span>
          <span><strong>WorkingDog VN</strong><small>Hồ sơ và phả hệ</small></span>
        </NavLink>
        {navigation}
        <Button variant="secondary" size="sm" onClick={() => setOpen(true)} className="mobile-only" aria-label="Mở điều hướng">Menu</Button>
      </header>
      <main className="page-container"><Outlet /></main>
      <footer className="footer"><span>WorkingDog VN</span><span>Tiếng Việt · Asia/Ho_Chi_Minh</span></footer>
      <Drawer open={open} title="Điều hướng WorkingDog VN" onClose={() => setOpen(false)}><div className="drawer-public-nav">{navigation}</div></Drawer>
    </div>
  );
}
